import React from 'react';
import {Popover} from '@material-ui/core';
import './PopoverMui.scss';
const PopoverMui = ({handleClose, open, anchorEl, children}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      PaperProps={{
        className: 'custom-popover'
      }}
    >
      {children}
    </Popover>
  );
};

export default PopoverMui;
